import { render, staticRenderFns } from "./VenueCard.vue?vue&type=template&id=342b1a89"
import script from "./VenueCard.vue?vue&type=script&lang=js"
export * from "./VenueCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports